import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { enrollmentServiceClient } from "../services/enrollment.service";
import { toast } from "sonner";

export const useEnrollments = (params) => {
  return useQuery({
    queryKey: ["enrollments", params],
    queryFn: () => enrollmentServiceClient.listEnrollments(params),
    keepPreviousData: true,
  });
};

export const useEnrollmentById = (id) => {
  return useQuery({
    queryKey: ["enrollment", id],
    queryFn: () => enrollmentServiceClient.getEnrollmentById(id),
    enabled: Boolean(id),
  });
};

export const useOnboardEnrollment = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id) => enrollmentServiceClient.onboardEnrollment(id),
    onSuccess: (_data, id) => {
      queryClient.invalidateQueries({ queryKey: ["enrollment", id] });
      queryClient.invalidateQueries({ queryKey: ["enrollments"] });
    },
  });
};

export const useResendOnboardingEmail = () => {
  return useMutation({
    mutationFn: (userId) =>
      enrollmentServiceClient.resendOnboardingEmail(userId),
    onSuccess: (data) => {
      toast.success(data.message || "Onboarding email resent successfully");
    },
    onError: (error) => {
      toast.error("Failed to resend email");
    },
  });
};

export const useResendSelfOnboardingEmail = () => {
  return useMutation({
    mutationFn: (userId) =>
      enrollmentServiceClient.resendSelfOnboardingEmail(userId),
    onSuccess: (data) => {
      toast.success(data.message || "Verification email resent successfully");
    },
    onError: (error) => {
      toast.error("Failed to resend email");
    },
  });
};
